<!-- WebGL Check -->
<div class="mb-4">
  <app-alert theme="light" type="danger" *ngIf="!supportsWegGl">
    <div class="text-12 text-bold">Warning!</div>
    <div class="text-12">
        Your browser does not support WebGL, which is required to run our 3D models. <a hef="https://support.biodigital.com/hc/en-us/articles/217800768--WebGL-Not-Supported-error" target="_blank">Learn more...</a>
    </div>
  </app-alert>
</div>

<!-- 1. Email -->
<div class="login__email" *ngIf="!(profileCheck$ | async)?.isUser">
  <div class="text-18 text-semibold text-center mb-8" data-test="signInInfoText">Sign in to continue</div>

  <!-- Group Name -->
  <div class="login__group" *ngIf="groupConfig.groupCodeMode === 1">
    {{ groupConfig.group }}
  </div>

  <!-- Email Form -->
  <form (submit)="handleEmailSubmit()" [formGroup]="formEmail">
    <!-- Email -->
    <app-form-field label="Email" data-test="emailLabel">
      <input class="input w-100" data-test="emailInput" name="email" type="email" formControlName="email" appAutoFocus>
      <div
        class="text-error text-12 mb-2"
        data-test="emailValidationText"
        *ngIf="(email.dirty && email.touched) && email.invalid && (email.errors.required || email.errors.email)">
          Please enter a valid email.
      </div>
    </app-form-field>

    <!-- Group Code -->
    <app-form-field label="Group Code" *ngIf="groupConfig.groupCodeMode === 1">
      <input class="input w-100" name="groupCode" type="text" formControlName="groupCode">
    </app-form-field>

    <!-- Error Message -->
    <div class="login__error" *ngIf="errorMessage" [innerHTML]="errorMessage">
    </div>

    <app-form-field>
      <button
        app-button
        buttonType="primary"
        buttonSize="medium"
        class="w-100"
        type="submit">
        <span *ngIf="!(loading$ | async)" data-test="nextButton">Next</span>
        <app-spinner size="medium" *ngIf="loading$ | async"></app-spinner>
      </button>
    </app-form-field>
  </form>

  <div class="text-center">
    <span class="text-12 mr-4" data-test="memberText">Not a member?</span>
    <button
      app-button
      type="button"
      buttonType="outline"
      buttonSize="small"
      buttonTheme="light"
      [uppercase]="false"
      class="w-40 mt-4"
      [routerLink]="['/login/create']"
      [queryParams]="{ group_invite: group_invite, code: code, group: group }"
      data-test="signUpButton">Sign Up for Free</button>
  </div>
</div>

<div class="login__validate" *ngIf="(profileCheck$ | async)?.isUser">
  <div class="login__loading" *ngIf="loading$ | async">
    <app-spinner size="huge" data-test="loginSpinner"></app-spinner>
  </div>

  <div *ngIf="(loading$ | async) === false">
    <!-- Welcome back -->
    <div class="login__welcome mb-4">
      <div class="text-18 text-semibold text-center mb-6" data-test="welcomeBackInfoText">Welcome back</div>
      <button
        app-button 
        [uppercase]="false" 
        buttonType="outline"
        buttonTheme="light" 
        class="w-100"
        (click)="handleBackClick()"
        data-test="signInBackButton">
        <fa-icon style="position: absolute; left: 0px;" icon="arrow-left"></fa-icon>
        {{ (profileCheck$ | async).email }}
      </button>
    </div>

    <!-- 2a. Biodigital Account -->
    <div class="login__biodigital" *ngIf="!(profileCheck$ | async)?.isThirdParty">
      
      <form (submit)="handlePasswordSubmit()" [formGroup]="formPassword">

        <!-- Password -->
        <app-form-field label="Password" data-test="passwordLabel">
          <input class="input w-100 mb-2" data-test="passwordInput" name="password" type="password" formControlName="password" appAutoFocus>
          <div class="text-error text-12 mb-2"
            *ngIf="(password.dirty && password.touched) && password.invalid && (password.errors.required)"
            data-test="passwordValidationText">
              Password is required.
          </div>

          <mat-checkbox formControlName="rememberMe" value="true" data-test="rememberMeCheckbox">
            <span class="text-12" data-test="rememberMeText">Remember me</span>
          </mat-checkbox>
        </app-form-field>

        <!-- Error Message -->
        <div class="login__error" *ngIf="errorMessage" [innerHTML]="errorMessage">
        </div>

        <!-- Submit -->
        <app-form-field>
          <button
            app-button
            buttonSize="medium"
            buttonType="primary"
            class="w-100"
            type="submit">
            <span *ngIf="!(loading$ | async)" data-test="signInButton">Sign In</span>
            <app-spinner size="medium" *ngIf="loading$ | async"></app-spinner>
          </button>
        </app-form-field>

        <!-- Forgot -->
        <div class="mt-4">
          <button
            app-button
            type="button"
            buttonTheme="light"
            [uppercase]="false"
            class="w-100"
            [routerLink]="['/login/reset']"
            data-test="forgotPasswordButton">Forgot your password?</button>
        </div>
        
      </form>
    </div>

    <!-- 2b. Third Party Account -->
    <div class="login__social" *ngIf="(profileCheck$ | async)?.isThirdParty">
      <!-- Google -->
      <app-form-field *ngIf="(profileCheck$ | async)?.thirdPartyProvider === 'Google'">
        <p class="text-12 text-semibold text-center mt-6 mb-6">
          Please sign in with your<br> Google credentials below.
        </p>
        <button 
          class="button button-medium button-google w-100 mb-2"
          type="button"
          (click)="handleGoogleClick()">
          <img src="/assets/images/google-icon.svg" style="width: 20px" class="mr-3">
          Sign in with Google
        </button>
      </app-form-field>

      <!-- Facebook -->
      <app-form-field *ngIf="(profileCheck$ | async)?.thirdPartyProvider === 'Facebook'">
        <p class="text-12 text-semibold text-center mt-6 mb-6">
          Please sign in with<br> your Facebook credentials below.
        </p>
        <button 
          class="button button-medium button-facebook w-100 mb-2"
          type="button"
          (click)="handleFacebookClick()">
          <img src="/assets/images/facebook-icon.svg" style="width: 20px" class="mr-3">
          Sign in with Facebook
        </button>
      </app-form-field>
    </div>
  </div>
</div>
